import { Col, Row } from 'antd';
import {
  CustomTable,
  CustomText,
  CustomTextArea,
  FormSelect,
} from '../../../../../components';

const ManageOneAsset = ({
  formik,
  items = {},
}: any) => {

  return (
    <>
      <Row style={{ marginBottom: '20px' }}>
        <Col xs={24} style={{ marginBottom: '16px' }}>
          <CustomText strong={true} text='Activo principal' />
        </Col>
        <Col xs={24}>
          <CustomTable
            columns={[
              {
                title: 'Ítem',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
              },
              {
                title: 'Activo',
                dataIndex: 'asset',
                key: 'asset',
                align: 'center',
              },
              {
                title: 'Código/Placa',
                dataIndex: 'plate_code',
                key: 'plate_code',
                align: 'center',
              },
              {
                title: 'Tipo clase',
                dataIndex: 'class',
                key: 'class',
              },
              {
                title: 'Observaciones',
                dataIndex: 'observations',
                key: 'observations',
                align: 'center',
              },
              {
                title: 'Justificación',
                dataIndex: 'justification',
                key: 'justification',
                align: 'center',
              }
            ]}
            dataSource={items}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
      {(!!items?.assets?.length && <Row style={{ marginBottom: '20px' }}>
        <Col xs={24} style={{ marginBottom: '16px' }}>
          <CustomText strong={true} text='Adiciones' />
        </Col>
        <Col xs={24}>
          <CustomTable
            columns={[
              {
                title: 'Ítem',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
              },
              {
                title: 'Activo',
                dataIndex: 'asset',
                key: 'asset',
                align: 'center',
              },
              {
                title: 'Código/Placa',
                dataIndex: 'plate_code',
                key: 'plate_code',
                align: 'center',
              },
              {
                title: 'Tipo clase',
                dataIndex: 'class',
                key: 'class',
              },
              {
                title: 'Observaciones',
                dataIndex: 'observations',
                key: 'observations',
                align: 'center',
              },
              {
                title: 'Justificación',
                dataIndex: 'justification',
                key: 'justification',
                align: 'center',
              }
            ]}
            dataSource={items.assets}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>)}
      {!!formik && (<>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormSelect
              label="Estado del elemento"
              name="status_id"
              placeholder="Seleccione la dependencia"
              value={formik.values.status_id}
              options={[
                {
                  name: 'Recibido',
                  id: '15'
                },
                {
                  name: 'Rechazado',
                  id: '10'
                }
              ]}
              error={formik.errors.status_id}
              touched={formik.touched.status_id}
              onChange={(value) =>
                formik.setFieldValue('status_id', value)
              }
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <CustomTextArea
              label="Observaciones"
              name="reason"
              placeholder="Observaciones"
              value={formik.values.reason}
              error={formik.errors.reason}
              touched={formik.touched.reason}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      </>)}
    </>
  );
};

export default ManageOneAsset;
